module.exports = __webpack_public_path__ + "img/lojaintegrada.2ff3ad08.png";